import { Typography } from '@mui/material';
import {
  Dialog,
  DialogActionsWithButtons,
  DialogContent,
  Show,
  useIsMobile,
} from '@side/pantry';
import { ListingSummaryCardMobile } from '@/components/ListingSummaryCard/ListingSummaryCardMobile';
import { ListingSummaryDesktop } from '@/components/ListingSummaryCard/ListingSummaryDesktop';
import { useListingSummary } from '@/components/ListingSummaryCard/useListingSummary';

type Props = {
  listingId?: string;
  onUseListing: (state: string | null) => void;
  onWrongListing: () => void;
  onClose: () => void;
};

export function ListingMatchDialog({
  listingId,
  onUseListing,
  onWrongListing,
  onClose,
}: Props) {
  const isMobile = useIsMobile();
  const { listing, loading } = useListingSummary({ listingId });

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={!!listingId}
      onClose={onClose}
      maxWidth="md"
    >
      <DialogContent onClose={onClose} title="We found an existing Listing">
        <Typography
          variant="body1"
          sx={{ pb: { xs: 2, md: 4 }, color: 'text.secondary' }}
        >
          Use your listing to autofill property and contact details
        </Typography>
        <Show
          when={isMobile}
          fallback={
            <ListingSummaryDesktop
              listingId={listingId ?? ''}
              loading={loading}
              coverPhotoUrl={listing?.coverPhotoUrl ?? null}
              fullAddress={listing?.formattedFullAddress ?? ''}
              interactionStatus={listing?.interactionStatus ?? ''}
              mlsNumber={listing?.mlsNumber ?? null}
              sellers={listing?.formattedSellers ?? ''}
              showMls
            />
          }
        >
          <ListingSummaryCardMobile
            listingId={listingId ?? ''}
            loading={loading}
            coverPhotoUrl={listing?.coverPhotoUrl ?? null}
            streetAddress={listing?.formattedStreetAddress ?? ''}
            cityStateZip={listing?.formattedCityStateZip ?? ''}
            mlsNumber={listing?.mlsNumber ?? null}
            sellers={listing?.formattedSellers ?? ''}
            showMls
          />
        </Show>
      </DialogContent>
      <DialogActionsWithButtons
        CancelButtonProps={{
          buttonText: 'Continue Without',
          onClick: onWrongListing,
        }}
        SubmitButtonProps={{
          defaultText: 'Use Listing',
          disabled: loading,
          onClick: () => onUseListing(listing?.state ?? null),
        }}
      />
    </Dialog>
  );
}
